import React, { FunctionComponent, memo } from "react";
import { useIntl } from "react-intl";
import { isEqual } from "lodash";

import StatsTable from "components/stats-table";
import BaseCard, { cardLabel, BaseCardProps } from "./BaseCard";
import { SiteConfig_siteConfig_dashboardConf_components } from "graphql/generated";
// import { DashboardMeasurement_dashboardMeasurement_factory } from "graphql/generated";

interface IProps extends BaseCardProps {
  data: any;
  config: SiteConfig_siteConfig_dashboardConf_components;
}

const FactoryCard: FunctionComponent<IProps> = memo(function Factory({ data, config, ...rest }) {
  const intl = useIntl();

  return (
    <BaseCard {...rest}
      title={intl.formatMessage({
        id: "dashboard__factory____title",
        defaultMessage: `{count, plural,
          one {Factory}
          other {Factories}
        } {label}`,
      }, {
        ...cardLabel(config),
      })}
      image={"/images/svg/tovarna.svg"}
    >
        <StatsTable
          inline
          rows={[
            {
              label: intl.formatMessage({
                id: "dashboard__factory__kw",
                defaultMessage: "Active power",
              }),
              unit: "kW",
              decimals: 2,
              // type: "number",
              value: data?.active_power,
            },
            {
              label: intl.formatMessage({
                id: "dashboard__factory__kwh_day",
                defaultMessage: "Consumption today",
              }),
              unit: "kWh",
              decimals: 0,
              // type: "number",
              value: data?.day_consumption_active_power,
            },
            {
              label: intl.formatMessage({
                id: "dashboard__factory__kwh_month",
                defaultMessage: "...and this month",
              }),
              unit: "kWh",
              decimals: 0,
              // type: "number",
              value: data?.month_consumption_active_power,
            },
          ]}
        />
    </BaseCard>
  );
}, isEqual);

export default FactoryCard;
